import React from 'react'
import type { BetSlipItem } from '@mobi/betslip/types'
import { isFobDetails, isRaceDetails } from '@mobi/betslip/helpers/typeGuards'
import { FobBetInfo, RaceBetInfo } from './Components'
import type { BetInfoDisplayType } from './types'

export const BetInfo: React.FC<{
  item: BetSlipItem
  isMultiItem?: boolean
  /** Used primarily for multi grouping @default 'full' */
  displayMode?: BetInfoDisplayType
}> = ({ item, isMultiItem, displayMode = 'full' }) => {
  if (isFobDetails(item.selectionDetails)) {
    return <FobBetInfo item={item} isMultiItem={isMultiItem} displayMode={displayMode} />
  }

  if (isRaceDetails(item.selectionDetails)) {
    return <RaceBetInfo item={item} isMultiItem={isMultiItem} displayMode={displayMode} />
  }

  return null
}
